import React from 'react';

const ImageBox = ({ noBg }) => {
  return (
    <>
      {noBg ? (
        <div className="w-full  mx-auto text-center">
          <div className="lg:container mx-auto px-6 lg:px-4 pb-5">
            <img loading="lazy" src="/static/images/landingPages/longterm.png" className="img img-fluid" alt="" />
          </div>
        </div>
      ) : (
        <div className="w-full text-center" style={{ backgroundColor: 'rgb(22, 22, 22)' }}>
          <div className="lg:container mx-auto px-6 lg:px-4 mx-auto py-5">
            <img loading="lazy" src="/static/images/landingPages/longterm.png" className="img img-fluid" alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageBox;
